import { merge } from 'lodash'
import { http } from 'utils'

// Docket mutation imports.
import { SET_DOCKET, RESET_DOCKET } from 'vx/mutations'

export const initialDocketState = (docket = {}) => {
  return merge({
    id: null,
    weighbridge_id: null,
    number: null,
    weight: null,
    type: null,
    status: null,
    rejection_reason: null,
    photo_path: null,
    photo_name: null,
    file_name: null,
    file: {}
  }, docket)
}

// Docket state.
const state = {
  docket: initialDocketState()
}

// Docket state getters.
const getters = {}

// Docket actions.
const actions = {
  /**
  * Update an existing docket's data.
  */
  updateDocket ({ commit }, { id, docket }) {
    let payload = new FormData()

    if (docket.file) {
      payload.append('file', docket.file)
    }

    if (docket.weight) {
      payload.append('weight', docket.weight)
    }

    if (docket.number) {
      payload.append('number', docket.number)
    }

    if (docket.file_name) {
      payload.append('file_name', docket.file_name)
    }

    return http.post(`dockets/${id}`, payload)
  },

  /**
   * Delete a docket.
   */
  deleteDocket ({ commit }, id) {
    return http.delete(`dockets/${id}`)
  },

  /**
   * Store a docket.
   */
  storeDocket ({ commit, rootState }, { weighbridge, docket }) {
    let payload = new FormData()

    payload.append('type', docket.type)
    payload.append('file', docket.file)

    if (docket.weight) {
      payload.append('weight', docket.weight)
    }

    if (docket.number) {
      payload.append('number', docket.number)
    }

    if (docket.file_name) {
      payload.append('file_name', docket.file_name)
    }

    return http.post(`weighbridges/${weighbridge}/dockets`, payload)
  },

  /**
   * Approve a docket.
   */
  approveDocket ({ commit }, id) {
    return http.post(`dockets/${id}/approve`).then(response => {
      return response
    })
  },

  /**
   * Reject a docket.
   */
  rejectDocket ({ commit }, { id, reason }) {
    return http.post(`dockets/${id}/reject`, { reason }).then(response => {
      return response
    })
  },

  /**
   * Rotate a docket.
   */
  rotateDocket ({ commit }, { id, amount }) {
    return http.post(`dockets/${id}/rotate`, { amount }).then(response => {
      return response
    })
  }
}

// Docket state mutations.
const mutations = {
  /**
   * Set the docket.
   */
  [SET_DOCKET] (state, docket) {
    state.docket = docket
  },

  /**
   * Reset the docket.
   */
  [RESET_DOCKET] (state) {
    state.docket = initialDocketState()
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/weighbridge/docket.js